import { Component, HostListener, Inject } from '@angular/core';
import type { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'app-slideshow-dialog',
    templateUrl: './slideshow-dialog.component.html',
    styleUrls: ['./slideshow-dialog.component.scss']
})
export class SlideshowDialogComponent extends DialogComponent {

    public activeIndex = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SlideshowDialogData,
        public dialogRef: MatDialogRef<SlideshowDialogComponent>
    ) {
        super();
        this.activeIndex = this.data.activeIndex || 0;
    }

    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        const key = event.key;

        if (key === 'ArrowRight' && this.activeIndex < this.data.items.length - 1) {
            return this.activeIndex++;
        }

        if (key === 'ArrowLeft' && this.activeIndex > 0) {
            return this.activeIndex--;
        }
    }

    public static show(dialog: MatDialog, data: SlideshowDialogData) {
        return dialog.open<SlideshowDialogComponent, SlideshowDialogData, boolean>(SlideshowDialogComponent, {
            data,
            panelClass: 'slideshow-dialog',
            maxWidth: '90vw',
            maxHeight: '90vh',
        });
    }
}

interface SlideshowDialogData {
    items: SlideshowItem[];
    activeIndex?: number;
}

export interface SlideshowItem {
    url: string;
    name: string;
}
